/**
 * Hash-части вкладок карточки игрока.
 *
 * Живут в `domain` по той же причине, что и `ChampionshipEditTab` с
 * `TeamViewTab`: hash — часть роута (`Pages.PLAYERS.builders.view`), а не
 * деталь вёрстки. Подписи и порядок вкладок — в
 * `ui/components/tabs-player-view.tsx`, где они привязаны к типу `Tab` из
 * `ud-ui`, которому в `domain` не место.
 */
export enum PlayerViewTab {
  COMMON = 'common',
  TEAMS = 'teams',
  MOMENTS = 'moments',
}
